import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  FormArray,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { format } from "date-fns";
import { forkJoin, Subscription, tap } from "rxjs";
import { TankmixRequest } from "src/app/models/tankmixRequest";
import { NamedId } from "../../models/NamedId";
import { ApiService } from "../../services/api.service";
import { PreferencesService } from "../../services/preferences.service";
import { ReferenceDataService } from "../../services/reference-data.service";

@Component({
  selector: "app-request",
  templateUrl: "./request.component.html",
})
export class RequestComponent implements OnInit {
  @ViewChild("formedEmail", { read: ElementRef }) formedEmail: ElementRef;

  yaraProductChoices: NamedId[] = [];
  tankmixRequestForm: UntypedFormGroup;
  applicationUnitChoices: string[] = [
    "Litres",
    "Millilitres",
    "Kilogrammes",
    "Grammes",
  ];
  countryChoices: NamedId[] = [];
  waterRateChoices: NamedId[] = [
    { id: "lt/Ha", name: "lt/Ha" },
    { id: "ga/Ac", name: "Gallons/Acre" },
  ];
  countryChosen: boolean = false;
  y;
  invalidIngredients: boolean = false;
  choicesSubscription: Subscription;
  constructor(
    private api: ApiService,
    private settings: PreferencesService,
    private fb: UntypedFormBuilder,
    private refData: ReferenceDataService,
    private router: Router
  ) {
    var today = new Date();
    this.tankmixRequestForm = this.fb.group({
      kind: ["Foliar"],
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      company: [null],

      crop: [null],
      countryCode: [null, Validators.required],
      requestDate: [format(today, "yyyy-MM-dd"), Validators.required],
      waterRate: [null, [Validators.required, Validators.min(0)]],
      waterRateUnits: ["lt/Ha"],
      comments: [null],
      ingredients: this.fb.array([]),
    });
  }

  get name() {
    return this.tankmixRequestForm.get("name");
  }
  get email() {
    return this.tankmixRequestForm.get("email");
  }
  get company() {
    return this.tankmixRequestForm.get("company");
  }
  get waterRate() {
    return this.tankmixRequestForm.get("waterRate");
  }
  get requestDate() {
    return this.tankmixRequestForm.get("requestDate");
  }

  ngOnInit() {
    // this.choicesSubscription = forkJoin(this.refData.getCountries())
    //   .pipe(
    //     tap((data: any) => {
    //       this.countryChoices = data[0];
    //     })
    //   )
    //   .subscribe();
    this.choicesSubscription = this.refData.getCountries()
      .subscribe((countries: NamedId[]) => {
        this.countryChoices = countries;   
      });

    this.settings.countryCode$.subscribe((countrycode) => {
      this.countryChosen = countrycode != null;
      this.tankmixRequestForm.patchValue({ countryCode: countrycode });

      // get products
      // this.refData.setCountry(countrycode).subscribe(x => { this.yaraProductChoices = x; });
    });
    this.tankmixRequestForm.valueChanges.subscribe((values) => {
      this.countryChosen = values.countryCode != null;
    });

    this.addProduct();
    this.addProduct();
  }
  get formValues(): any {
    return this.tankmixRequestForm.value;
  }
  get ingredients() {
    return this.tankmixRequestForm.get("ingredients") as FormArray;
  }

  changeCountry() {
    this.api.getYaraProducts(this.formValues.countryCode).subscribe((x) => {
      this.yaraProductChoices = x;
    });
  }

  addProduct() {
    this.ingredients.push(
      this.fb.group({
        name: [null, Validators.required],
        orderOfAddition: this.ingredients.length + 1,
        applicationRate: [null, Validators.required],
        applicationUnit: ["Litres", Validators.required],
      })
    );
  }
  deleteProduct(index) {
    console.log("Deleting product");
    this.ingredients.removeAt(index);
  }
  submitRequest() {
    this.invalidIngredients = false;

    if (this.tankmixRequestForm.valid) {
      // check if there are ingredients. Do not submit form if ingredients = 0
      if (!this.areIngredientsInvalid()) {
        console.log("valid ingredients");
        const html = document.getElementById("formedEmail").innerHTML;
        var values = this.tankmixRequestForm.value;

        var req: TankmixRequest = {
          kind: values.kind,
          name: values.name,
          email: values.email,
          company: values.company,
          crop: values.crop,
          countryCode: values.countryCode,
          requestDate: values.requestDate,
          waterRate: values.waterRate,
          waterRateUnits: values.waterRateUnits,
          comments: [{ comment: values.comments }],
          ingredients: values.ingredients,
        };

        this.api.submitRequest(req, html).subscribe((data) => {
          this.router.navigateByUrl("request-submitted");
        });
      } else {
        console.log("no ingredients data - Invalid submission");
      }
    }
  }

  areIngredientsInvalid() {
    var result =
      this.ingredients.controls.some(
        (x) => x.get("name").value === null || x.get("name").value === ""
      ) ||
      this.ingredients.controls.some(
        (x) =>
          x.get("applicationRate").value === null ||
          x.get("applicationRate").value === ""
      );
    console.log(result);
    this.invalidIngredients = result;
    return result;
  }
}
